import { render, staticRenderFns } from "./TransferBasicProcessingDialog.vue?vue&type=template&id=59dbb11c&"
import script from "./TransferBasicProcessingDialog.vue?vue&type=script&lang=js&"
export * from "./TransferBasicProcessingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports